import api from '@/services/api';

import { getCurrentLanguage } from '@/helpers/AppHelpers';

export default {
  getProgressif() {
    // Populer contenu store progressif.progressifLive
    return api
      .call(`lots/api/v1/progressifs`, 'progressifService', 'GET', {
        params: {
          lang: getCurrentLanguage(),
        },
      })
      .then((response) => {
        return response.data;
      });
  },
};
